/* global google */
const util = require('./util')

const googleChartsUrls = 'https://www.gstatic.com/charts/loader.js'

const mapOptions = {
  displayMode: 'regions',
  tooltip: { isHtml: true },
  region: 'world',
  datalessRegionColor: '#e8e9f1', // light version of sapphire
  defaultColor: '#e8e9f1',
  colorAxis: {
    colors: [
      // scheme from http://www.0to255.com/454A73
      '#bdc0d8', // more lightness
      '#9397be',
      '#5e659d',
      '#454A73' // sapphire
    ]
  }
}

class GlobalMap {
  constructor (config) {
    this.mapContainer = document.querySelector(config.mapContainer)
    this.resetButton = document.querySelector(config.button)
    this.resetButton.addEventListener('click', this.resetMap.bind(this))

    this.locations = config.locations
    this.options = prepareMapOptions(this.mapContainer)
    util.loadScript(googleChartsUrls, () => {
      google.charts.load('current', { packages: ['geochart'] })
      google.charts.setOnLoadCallback(this.drawMap.bind(this))
    })
  }

  resetMap () {
    this.options.region = 'world'
    this.drawMap()
  }

  drawMap () {
    const mapData = this.prepareMapData(this.locations)
    const chart = new google.visualization.GeoChart(this.mapContainer)
    chart.draw(mapData, this.options)
    this.updateResetButton()
    this.listenForClicks(chart)
  }

  updateResetButton () {
    if (this.options.region === 'world') {
      this.resetButton.setAttribute('hidden', '')
    } else {
      this.resetButton.removeAttribute('hidden')
    }
  }

  listenForClicks (chart) {
    google.visualization.events.addListener(chart, 'regionClick', (event) => {
      if (this.getMapMode() === 'zoomed') {
        const found = this.locations.find(location => location.country_code === event.region)
        if (found && found.count > 0) {
          window.location.href = `/profile/location/${found.country_code}`
        }
      } else {
        this.options.region = event.region
        this.drawMap()
      }
    })
  }

  getMapMode () {
    return this.options.region === 'world' ? 'world' : 'zoomed'
  }

  prepareMapData () {
    const mode = this.getMapMode()
    const data = new google.visualization.DataTable()
    data.addColumn('string', 'Country')
    data.addColumn('number', '.eco profiles')
    data.addColumn({ type: 'string', role: 'tooltip', p: { html: true } })
    data.addRows(this.locations.map(location => {
      return [location.country_code, location.count || null, buildTooltip(location, mode)]
    }))
    return data
  }
}

function prepareMapOptions (container) {
  const background = window.getComputedStyle(container).getPropertyValue('background-color')
  return Object.assign(mapOptions, { backgroundColor: { fill: background } })
}

function buildTooltip (location, mode) {
  const countryLabel = `<p class="doteco-global-map-tooltip__country">${location.country_label}</p>`
  const profileCount = location.count ? `<p class="doteco-global-map-tooltip__profiles">.eco profiles: <strong>${location.count}</strong></p>` : ''
  return `${countryLabel}${profileCount}${buildTooltipCta(location, mode)}`
}

function buildTooltipCta (location, mode) {
  let cta
  if (mode === 'world') {
    cta = 'Click to zoom'
  } else if (location.count) {
    cta = 'Click to view profiles'
  }
  return cta ? `<p class="doteco-global-map-tooltip__cta">${cta}</p>` : ''
}

export function init (config) {
  return new GlobalMap(config)
}
